import { Link } from 'react-router-dom'
import { useHistory } from 'react-router'
import React, { useState, useRef } from 'react'

import Button from 'components/Button'
import useCart from 'store/CartProvider'
import { Basket } from 'components/Icons'
import Close2 from 'components/Icons/Close2'
import CartIcon from 'components/Icons/Cart'
import detectOutside from 'helpers/detectOutside'
import HeaderCartItem from 'components/Header/components/HeaderCartItem'

export const Cart = props => {
  const [open, setOpen] = useState(false)
  const { products } = useCart()
  const history = useHistory()

  const handleOpen = e => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const BasketRef = useRef(null)
  detectOutside(BasketRef, handleClose)

  return (
    <div ref={BasketRef} className="relative">
      <div
        onClick={handleOpen}
        className="cursor-pointer pt-1 relative md:ml-6.5"
      >
        <Basket width="25" height="25" />
        {products.length ? (
          <span className="absolute w-4 h-4 rounded-full bg-[#ff2337] text-[10px] text-white flex items-center justify-center right-[-17%] top-[25%] transform -translate-y-1/2">
            {products.length}
          </span>
        ) : null}
      </div>

      <div
        className={`absolute top-11 -right-6 z-[999] w-80 sm:w-[400px] transition-all duration-300 ease-in-out border border-[#ff2337] rounded-md ${
          open
            ? 'opacity-100 scale-100 translate-y-0'
            : 'opacity-0 scale-90 translate-y-5 pointer-events-none'
        }`}
      >
        <div className="absolute -top-[7px] right-[29px] w-3 h-3 bg-white border-l border-t border-[#ff2337] transform rotate-45"></div>

        <div className="bg-white rounded-md overflow-hidden">
          <div className="p-3 border-b border-slate-200 flex justify-between items-center">
            <h2 className="text-base font-bold text-[#2d3748] flex items-center gap-2">
              ჩემი კალათა
            </h2>
            <button onClick={handleClose} className="pr-2">
              <Close2 height={10} width={10} />
            </button>
          </div>

          <div className="p-3">
            {!products.length ? (
              <div className="text-center text-[#a0a0a0] py-4">
                <CartIcon height={30} width={30} />
                <h3 className="text-base md:text-lg">კალათა ცარიელია</h3>
                <p className="text-sm md:text-base">გთხოვთ აირჩიოთ პროდუქცია</p>
              </div>
            ) : (
              <div
                className={`hide-scrollbar border-b border-slate-200 pb-4 max-h-[300px] overflow-y-auto overflow-x-hidden -mx-4 pr-8 pl-4  ${
                  products.length ? 'text-left' : 'text-center'
                }`}
              >
                {products.map((c, index) => (
                  <div key={c.sku}>
                    <HeaderCartItem product={c} />
                  </div>
                ))}
              </div>
            )}

            <div className="mt-3">
              {products.length ? (
                <Button
                  color="orange"
                  onClick={() => {
                    history.push('/purchase')
                    handleClose()
                  }}
                  className="w-full text-sm font-bold h-10 flex items-center justify-center hover:shadow-lg hover:scale-[1.02] hover:brightness-110 transition-all duration-200 ease-in-out active:scale-95"
                >
                  ყიდვა
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
